<template>
<div class="flex-fill">
  <v-row no-gutters v-if="field.constructor.name === 'Boolean' || (field_key.toLowerCase().includes('is_') || ['retest','passed','complete','active', 'qa_approved', 'billing_approved'].includes(field_key))">
    <v-col cols="1">
      <v-checkbox v-model="selected" class="pa-0 ma-0" @change="$emit('toggle_field', field_key)" dense></v-checkbox>
    </v-col>
    <v-col>
      <v-radio-group
          class="ma-0 pa-0"
          :value="value"
          @change="$emit('input', $event)"
          :label="label.replace(' UUID', '')"
          dense
          row
          :disabled="!selected"
      >
        <v-radio label="True" :value="true"></v-radio>
        <v-radio label="False" :value="false"></v-radio>
      </v-radio-group>
    </v-col>
  </v-row>
  <template v-else>
    <v-row no-gutters>
      <v-col cols="1">
        <v-checkbox :value="selected" @change="$emit('toggle_field', field_key)" dense></v-checkbox>
      </v-col>
      <v-col cols="3" v-if="!field_key.includes('_date') && !(field_key === 'created_by' || field_key === 'updated_by' || field_key.includes('uuid')) || field_key === 'customer_id'">
        <v-select :value="value.condition" label="Condition" :items="conditions" dense
                  @input="$emit('input:condition', {...value, condition:$event})"
                  outlined
        :disabled="!selected">
        </v-select>
      </v-col>
      <v-col>
        <v-menu v-if="field_key.includes('_date')">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="value.value"
                @input="$emit('input', {...value, value: $event})"
                :label="label"
                readonly
                v-bind="attrs"
                v-on="on"
                dense
                outlined
                clearable
                :disabled="!selected"
            ></v-text-field>
          </template>
          <v-date-picker
              :value="value.value"
              @input="$emit('input', {...value, value: $event})"
              no-title
              scrollable
          >
          </v-date-picker>
        </v-menu>
        <v-autocomplete
            v-else-if="field_key === 'created_by' || field_key === 'updated_by'"
            :value="value.value"
            @input="$emit('input', {...value, value: $event})"
            :label="label"
            :items="$store.state.userListArray"
            item-text="displayName"
            item-value="uid"
            dense
            clearable
            outlined
        :disabled="!selected">
        </v-autocomplete>
        <v-autocomplete
            v-else-if="this.relationModel"
            :value="value.value"
            @input="$emit('input', {...value, value: $event})"
            :label="label"
            :items="this.relationModel.all()"
            item-text="name"
            item-value="uuid"
            dense
            clearable
            :loading="loading"
            :disabled="loading || !selected"
            outlined>
        </v-autocomplete>
        <v-autocomplete
            v-else-if="field_key==='customer_id'"
            :value="value.value"
            @input="$emit('input', {...value, value: $event})"
            :items="$store.$db().model('customers').all()"
            item-text="name"
            item-value="customer_id"
            :label="label.replace('_ID')"
            dense
            clearable
            outlined
            :disabled="!selected"
        >
        </v-autocomplete>
        <v-text-field
            :value="value.value"
            @input="$emit('input', {...value, value: (field.constructor.name === 'Number' ? Number($event) : $event)})"
            v-else
            :label="label"
            dense
            outlined
            :disabled="!selected"
        >
        </v-text-field>
      </v-col>
    </v-row>
  </template>
</div>
</template>

<script>
export default {
    name: "QueryField",
    components: {},
    data: () => ({
      loading: false,
      relationModel: null,
      conditions: [
        "=",
        "!=",
        ">",
        ">=",
        "<",
        "<=",
        "LIKE",
      ],
    }),
    props:{
      field: {
        required: true,
      },
      field_key:{
        required: true,
      },
      selected: {
        default: false,
        type: Boolean,
      },
      label: {
        required: false,
        default: ''
      },
      value:{
        default: null,
      },
    },
    mounted(){
      // console.log(field)
        if(this.field_key.includes("type_uuid")){
          let foreignKeyCheck = this.isForeignKey();
          if(foreignKeyCheck){
              this.relationModel = foreignKeyCheck.parent ? foreignKeyCheck.parent : foreignKeyCheck.related;
              this.getData();
          }
        }
    },
    methods: {
      async getData(){
        if(this.relationModel.all().length > 0) return;
        this.loading = true;
        await this.relationModel.api().fetch();
        this.loading = false;
      },
      isForeignKey(){
        let values = Object.values(this.field.model.fields());
        let find = values.find(property => property.foreignKey === this.field_key);
        return find;
      }
    }
}
</script>

<style scoped>

</style>
